export const RouteList = {
  // system management pages
  Root : { path: "/"},
  Home : { path: "/home"},
  Help : { path: "/help"},
  Signin: { path: "/system/signin"},
  Signup: { path: "/system/signup"},
  MailAuthentication: { path: "/system/mail-authentication"},
  HelpSignin: { path: "/system/signin/help"},
  TwoFactorAuthentication: { path: "/system/2fa"},
  ChangePassword: { path: "/system/password"},
  ForgotPassword: { path: "/system/forgot-password"},
  ResetPassword: { path: "/system/reset-password"},
  NotFound: { path: "/system/404" },

  // main tabs
  SCM: { path: "/scm"},

};
